module.exports = __webpack_public_path__ + "img/yellow.c64a927e.png";